import { useEffect, useState, useContext } from 'react'
import ImageWithBasePath from './ImageWithBasePath'
import { HamburgerAnimation } from './HamburgerAnimation'
import { useRouter } from 'next/router'
import { DEFAULT_HEADER_WITH_BORDER, NO_HEADER_PAGES, SECONDARY_HEADERS } from '../constants/all'
import classNames from 'classnames'
import { DefaultHeader } from '../components/DefaultHeader'
import { useRouterHook } from '../hooks/useRouterHook'
import { Media } from '../commonComponents/Media'
import { LocationShow } from './LocationShow'
import Popover from 'antd/lib/popover'
import _JSXStyle from 'styled-jsx/style'
import { HamburgerMenu } from './HamburgerMenu'
import { NextLink } from '../commonComponents/NextLink'
import { SharedContext } from '@/context/SharedContext'
import { SeekerContext } from '@/context/SeekerContext'
import { AdvertiserContext } from '@/context/AdvertiserContext'

const HomePageHeader = ({ isMenuClicked = false }) => {
  const router = useRouter()
  const hirePathRegex = /^(?:\/hire|\/recruit)(?:[\/?#].*)?$/;
  const isHire = hirePathRegex.test(router?.asPath);

  return (
    <div
      className={classNames(
        'flex h-[17px] cursor-pointer items-end space-x-[5.54px] pl-[12px]  sm:h-full sm:items-center sm:pl-[0px]',
        isMenuClicked && 'h-[22px] animate-slide  sm:animate-none',
        isHire && 'pl-[18px]'
      )}
    >
      <div id="app_logo">
        <Media at="sm" className="flex items-end gap-1">
          <ImageWithBasePath
            src="desktop_logo"
            height={isMenuClicked ? 22 : 17}
            width={isMenuClicked ? 23.329 : 16.966}
            alt="getlokalapp logo"
          />
          <ImageWithBasePath
            src="lokal_app_text"
            height={isMenuClicked ? 15.923 : 12.305}
            width={isMenuClicked ? 85.037 : 61.845}
            alt="getlokalapp logo"
          />
        </Media>
        <Media greaterThanOrEqual="md">
          <ImageWithBasePath src="appLogo" height={30.91} width={160} alt="getlokalapp logo" />
        </Media>
      </div>
    </div>
  )
}

const SecondaryHeader = ({ title, backNavigation }) => {
  return (
    <div className="rounded-none flex h-full w-full items-center space-x-[8px] border-[0px] border-b-[1px] border-solid border-xLigthGray bg-white px-[12px] py-sm text-md leading-[21.79px] text-[#323234]">
      <div
        id="secondary_header_navigation"
        className="flex h-fit w-fit cursor-pointer items-center"
        onClick={backNavigation}
      >
        <ImageWithBasePath src="navigationIcon" width={24} height={24} alt="back arrow" />
      </div>
      <NextLink
        href="seekerHomePage"
        as="jobs"
        isLoader={false}
        id="secondary_header_logo"
        className="relative h-[24px] w-[24px]"
      >
        <ImageWithBasePath src="logo" fill alt="logo of Lokal" />
      </NextLink>
      <div id="secondary_header_title" className="ml-sm select-none">
        {title}
      </div>
    </div>
  )
}

const LocationHeader = ({ title, location }) => {
  const { navigateToPagesInSeeker } = useRouterHook()

  const NavigateBack = () => {
    if (location?.title || location?.name) {
      navigateToPagesInSeeker({
        pathName: `seekerHomePage`,
        as: `${(location?.title || location?.name).toLowerCase()}`
      })
    } else {
      navigateToPagesInSeeker({
        pathName: `seekerHomePage`,
        as: '/'
      })
    }
  }

  return (
    <div className="rounded-none flex h-full w-full items-center space-x-[8px] border-[0px] border-solid border-xLigthGray bg-white px-[12px] py-sm text-md leading-[21.79px] text-[#323234]">
      <div
        id="secondary_header_navigation"
        className="flex h-fit w-fit cursor-pointer items-center"
        onClick={() => NavigateBack()}
      >
        <ImageWithBasePath src="navigationIcon" width={24} height={24} alt="back arrow" />
      </div>
      <div id="secondary_header_title" className="ml-sm select-none">
        {title}
      </div>
    </div>
  )
}

export const Header = ({
  setMenuClicked,
  isMenuClicked,
  locationHandler,
  backNavigation,
  isLocationPage
}) => {
  const router = useRouter()
  const pathname = router?.pathname?.split('/')?.[1]
  const isHomePage = pathname == 'seekerHomePage' || pathname?.length <= 0
  const isHeaderPresent = !(NO_HEADER_PAGES || []).includes(pathname)
  const hirePathRegex = /^(?:\/hire|\/recruit)(?:[\/?#].*)?$/;
  const isHire = hirePathRegex.test(router?.asPath);
  const {
    location,
    setScrollBar,
    windowSize
  } = useContext(SharedContext);

  const seekerContext = !isHire
  ? useContext(SeekerContext)
  : null
const advertiserContext = isHire
  ? useContext(AdvertiserContext)
  : null
  
  const {
    pageTitles,
    setFilterNameWFH,
    setLogInOpen,
    isJobProfileCreated,
    setIsJobProfileCreated,
    setBody
  } = seekerContext || {}
  
  const {
    enterpriseLoginDetails,
    setEnterpriseLoginDetails,
    setAdvertiserBackModalOpen,
    setAdvertiserMenuClicked,
    advertiserBackModalClose
  } = advertiserContext || {}

  const isSecondaryHeader = Object.keys(SECONDARY_HEADERS).includes(pathname)
  const isDefaultHeader = !isHomePage && !isSecondaryHeader
  const [hydrated, setHydrated] = useState(false)
  const { routerBackNavigation } = useRouterHook()

  useEffect(() => {
    setHydrated(false)
  }, [])

  if (hydrated) return

  return (
    isHeaderPresent && (
      <div
        id="header"
        className={classNames(
          'sticky top-0 z-20 flex h-[44px] items-center justify-between bg-white sm:h-[80px] sm:border-[0px] sm:border-b-xs sm:border-solid sm:border-[#F2F2F3] sm:px-[40px]',
          isSecondaryHeader ? '' : 'pr-15',
          DEFAULT_HEADER_WITH_BORDER?.includes(pathname) &&
            'border-[0px] border-b-[1px] border-solid border-xLigthGray'
        )}
        onClick={() => {
          setFilterNameWFH('')
        }}
      >
        <div
          className={classNames('flex flex-col', pathname === 'jobDetails' ? 'w-full' : 'w-[62%]')}
        >
          <Media greaterThan="sm">
            <HomePageHeader
              {...{
                isMenuClicked,
                isMobile: false
              }}
            />
          </Media>

          <Media at="sm">
            {(isHomePage || isMenuClicked) && (
              <HomePageHeader
                {...{
                  isMenuClicked,
                  isMobile: true
                }}
              />
            )}
            {isLocationPage && !isMenuClicked && !isHomePage && (
              <LocationHeader title={'Select Location'} location={location} />
            )}
            {isDefaultHeader && !isMenuClicked && !isLocationPage && (
              <DefaultHeader
                {...{
                  title: pageTitles?.[pathname]?.[pageTitles?.[pathname]?.length - 1] || pathname,
                  backNavigation
                }}
              />
            )}
            {isSecondaryHeader && !isMenuClicked && (
              <SecondaryHeader
                title={SECONDARY_HEADERS[pathname]}
                backNavigation={backNavigation}
              />
            )}
          </Media>
        </div>
        {(!isSecondaryHeader || windowSize > 640) && (
          <div className="flex items-center">
            {isHomePage && (
              <Media at="sm">
                <LocationShow {...{ isHomePage, isMenuClicked, location, locationHandler }} />
              </Media>
            )}
            {isDefaultHeader && !isLocationPage && router?.pathname != '/sitemap' && (
              <Media at="sm">
                <LocationShow {...{ isHomePage, isMenuClicked, location, locationHandler }} />
              </Media>
            )}

            <Media at="sm">
              <div
                id="header_burger_menu"
                className={
                  !isLocationPage
                    ? 'flex h-fit w-fit cursor-pointer items-center pl-[10px]'
                    : 'flex h-fit w-fit cursor-pointer items-center border-[0px] border-l-xs border-solid border-l-[#E5E5E6] pl-[10px]'
                }
                onClick={() => {
                  if (isMenuClicked && router.pathname === '/seekerHomePage') routerBackNavigation()
                  setMenuClicked((prv) => !prv)
                  setScrollBar((prv) => !prv)
                }}
              >
                <HamburgerAnimation {...{ isClicked: isMenuClicked }} />
              </div>
            </Media>
            <Media greaterThan="sm">
              <Popover
                trigger="click"
                placement="bottomLeft"
                showArrow={false}
                overlayClassName="p-[0px] pt-[10px] m-[0px]"
                open={isMenuClicked}
                content={() => (
                  <HamburgerMenu
                    {...{
                      setMenuClicked,
                      isMenuClicked,
                      setLogInOpen,
                      isJobProfileCreated,
                      setIsJobProfileCreated,
                      setBody,
                      enterpriseLoginDetails,
                      setEnterpriseLoginDetails,
                      setAdvertiserBackModalOpen,
                      setAdvertiserMenuClicked,
                      advertiserBackModalClose
                    }}
                  />
                )}
              >
                <div
                  className="flex h-[50px] items-center space-x-[8px] rounded-xs border-xs border-solid border-[#CBCBCD] px-[12px] py-[8px] sm:ml-[24px]"
                  onClick={() => {
                    setMenuClicked((prv) => !prv)
                    setScrollBar((prv) => !prv)
                  }}
                >
                  <div className="relative h-[24px] w-[24px]">
                    <ImageWithBasePath src="desktop_menu" fill alt="menu icon" />
                  </div>
                  <div className="relative h-[34px] w-[34px]">
                    <ImageWithBasePath src="person_in_circle" fill alt={'profile photo'} />
                  </div>
                </div>
                <style jsx global>{`
                  .ant-popover .ant-popover-inner {
                    border-width: 0px;
                    border-radius: 10px;
                    padding: 0px;
                    box-shadow: none;
                  }
                `}</style>
              </Popover>
            </Media>
          </div>
        )}
      </div>
    )
  )
}
